module.exports = __webpack_public_path__ + "static/img/business_host.55cc674.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business_host.png
// module id = goSr
// module chunks = 1